import React from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
} from "react-bootstrap";
import {
  FaGooglePlay,
  FaApple,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaPhoneAlt,
  FaEnvelope,
  FaClock,
  FaArrowRight,
} from "react-icons/fa";

const scrollTop = () => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth",
  });
};

const Footer = () => {
  return (
    <footer className="footer-section">

      
      <Container>

        <div className="newsletter-box">

          <Row className="align-items-center">

            <Col lg={6}>
             <div className="d-flex align-items-center flex-column flex-lg-row">

                <div className="footer-logo">
                  <span>K</span>RIMOTION
                </div>

              

              </div>
            </Col>

            

          </Row>

        </div>

        <hr className="footer-line" />

        <Row className="gy-5">

 

          <Col lg={3} md={6}>

            <h5>ABOUT KRIMOTION</h5>

            <div className="title-line"></div>

            <p>
            We focus on building strong relationships by providing a reliable platform where drivers, dealers, and customers can connect with confidence.
            </p>

            <div className="social-icons">

              <FaFacebookF />
              <FaInstagram />
              <FaLinkedinIn />

            </div>

          </Col>

          {/* Links */}

          <Col lg={3} md={6}>
  <h5>QUICK LINKS</h5>

  <div className="title-line"></div>

 <ul className="list-unstyled">

  <li>
    <Link
      to="/"
      className="footer-link"
      onClick={scrollTop}
    >
      Home
    </Link>
  </li>

  <li>
    <Link
      to="/about"
      className="footer-link"
      onClick={scrollTop}
    >
      About
    </Link>
  </li>

  <li>
    <Link
      to="/privacy-policy"
      className="footer-link"
      onClick={scrollTop}
    >
      Privacy Policy
    </Link>
  </li>

  <li>
    <Link
      to="/contact"
      className="footer-link"
      onClick={scrollTop}
    >
      Contact
    </Link>
  </li>

</ul>
</Col>

       

<Col lg={3} md={6} className="ps-lg-0 ps-md-3">

  <h5>DOWNLOAD OUR APP</h5>

  <div className="title-line"></div>

  <p className="mb-4">
    Download the krimotion app for quick booking,
    order tracking and seamless services.
  </p>

  <Button
    className="w-100 border-0 rounded-0 d-flex align-items-center justify-content-center fw-semibold"
    style={{
      backgroundColor: "var(--primary-color)",
      color: "#fff",
      minHeight: "55px",
    }}
  >
    <FaGooglePlay className="me-2 fs-5" />
    <span>Google Play</span>
  </Button>

</Col>
        

          <Col lg={3} md={6}>

            <h5>GET IN TOUCH</h5>

            <div className="title-line"></div>

            <div className="contact-item">

              <FaPhoneAlt />

              <span>+1 (234) 567-8900</span>

            </div>

            <div className="contact-item">

              <FaClock />

              <span>Mon - Sat : 9AM - 6PM</span>

            </div>

            <div className="contact-item">

              <FaEnvelope />

              <span>info@krimotion.in</span>

            </div>

          </Col>

        </Row>

        <hr className="footer-line" />

        <div className="copyright">

          © 2026 KRIMOTION. All Rights Reserved.

        </div>

      </Container>

    </footer>
  );
};

export default Footer;